import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { initPushAndDeepLinks } from "../lib/native/pushdeep";

// Ponte nativo montato dentro il Router: inizializza push + deep link una volta
// che l'utente è autenticato (i token vanno associati a un account). No-op sul web.
export default function NativeBridge() {
  const navigate = useNavigate();
  const { user } = useAuth();
  useEffect(() => {
    if (user) initPushAndDeepLinks(navigate);
  }, [user]); // eslint-disable-line
  return null;
}
